<section class="px-5 pt-[10rem] lg:pt-56 pb-16 max-w-2xl mx-auto text-left">
    <div class="text-center">
        <p class="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-green-100 text-3xl text-primaryDark" aria-hidden="true">✓</p>
        <h1 class="pt-3 text-2xl lg:text-4xl font-bold text-gray-900">Ти благодариме за нарачката!</h1>
        @if (productsText) {
            <p class="pt-2 text-gray-700">{{ productsText }}</p>
        }
    </div>

    <h2 class="pt-8 text-lg font-semibold text-gray-900">Што следи</h2>
    <ol class="mt-3 space-y-3 list-none pl-0">
        <li class="flex gap-3">
            <span class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primaryDark text-sm font-semibold text-white">1</span>
            <span class="text-gray-800">Нарачката е примена и се процесира. Ако сте оставиле е-маил, потврдата ќе стигне таму.</span>
        </li>
        <li class="flex gap-3">
            <span class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primaryDark text-sm font-semibold text-white">2</span>
            <span class="text-gray-800">Ако имаме прашање за нарачката или адресата, ќе ве контактираме на телефонскиот број.</span>
        </li>
        <li class="flex gap-3">
            <span class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primaryDark text-sm font-semibold text-white">3</span>
            <span class="text-gray-800">Пратката ја носи курир за просечно <span class="whitespace-nowrap">{{ deliveryTime }}</span>. Плаќате во готово кога ќе ја примите.</span>
        </li>
    </ol>
    <p class="pt-4 text-sm text-gray-600">
        Прашања? Јавете се или пишете на Viber: <a class="text-primaryDark underline whitespace-nowrap" href="tel:+38973857133">073/857-133</a>
    </p>

    @if (order && order.productIds.length > 0) {
        <div class="mt-8 rounded-lg border border-green-200 bg-green-50 p-4 lg:p-6">
            <h2 class="text-lg font-semibold text-gray-900">Потсети ме кога ќе ми снема</h2>
            @if (reminderSet) {
                <p class="pt-2 text-green-800" role="status">Готово! Ќе ви пратиме еден мејл {{ reminderLabel }}.</p>
            } @else {
                <p class="pt-1 text-sm text-gray-700">Ќе ви пратиме само еден мејл со линк за повторна нарачка. Адресата не ја користиме за ништо друго.</p>
                <form class="mt-3 grid gap-3 sm:grid-cols-[1fr_auto]" [formGroup]="reminderForm" (ngSubmit)="setReminder()" novalidate>
                    <label class="block text-sm font-medium text-gray-800">
                        Е-маил
                        <input class="mt-1 block w-full rounded border border-gray-300 px-3 py-2 font-normal focus:border-primaryDark focus:outline-none"
                               type="email" inputmode="email" autocomplete="email" formControlName="email">
                        @if (reminderForm.controls.email.touched && reminderForm.controls.email.invalid) {
                            <span class="text-red-600 font-normal">Внесете точна е-маил адреса.</span>
                        }
                    </label>
                    <label class="block text-sm font-medium text-gray-800">
                        Кога
                        <select class="mt-1 block w-full rounded border border-gray-300 px-3 py-2 font-normal" formControlName="days">
                            @for (option of reminderOptions; track option.days) {
                                <option [ngValue]="option.days">{{ option.label }}</option>
                            }
                        </select>
                    </label>
                    <!-- Hidden from people; bots fill every field. -->
                    <input class="hidden" formControlName="website" tabindex="-1" autocomplete="off" aria-hidden="true">
                    <div class="sm:col-span-2 flex flex-wrap items-center gap-3">
                        <button type="submit"
                                class="rounded bg-primaryDark px-6 py-2.5 font-medium text-white hover:bg-primaryDarker transition disabled:opacity-60"
                                [disabled]="sending">{{ sending ? 'Се зачувува…' : 'Потсети ме' }}</button>
                        @if (reminderFailed) {
                            <span class="text-sm text-red-600" role="alert">Не успеа. Обидете се повторно.</span>
                        }
                    </div>
                </form>
            }
        </div>
    }

    <div class="pt-8 text-center">
        <a class="inline-block rounded border-2 border-primaryDark px-6 py-2.5 font-medium text-primaryDark hover:bg-primaryDark hover:text-white transition"
           routerLink="/shop">Назад кон продавницата</a>
    </div>
</section>
